import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const OBDIntegration = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        OBD Entegrasyonu
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>OBD entegrasyonu burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default OBDIntegration;
